import styled from 'styled-components'
import { iPadDown } from '../../../styles/mediaQueries'
import { DolaThemes } from '../../../styles/types'
import theme from './theme'

export const Progress = styled.div`
  display: flex;
`

interface NumberIconProps {
  mode: 'active' | 'default'
  dolaTheme: DolaThemes
}

export const NumberIcon = styled.div<NumberIconProps>`
  align-items: center;
  background: ${({ mode, dolaTheme }) => theme[dolaTheme][mode].icon};
  border-radius: 50%;
  color: ${({ mode, dolaTheme }) => theme[dolaTheme][mode].text};
  display: flex;
  height: 1.56vw;
  justify-content: center;
  transition: all 0.2s ease 0.4s;
  width: 1.56vw;

  p {
    position: relative;
    top: 0.01vw;
  }

  ${iPadDown} {
    border-radius: 3vw;
    height: 6vw;
    padding: 0 2vw;
    width: 6vw;
  }
`

interface ProgressItemProps {
  clickable: boolean
  items: number
  short: boolean
}

export const ProgressItem = styled.div<ProgressItemProps>`
  display: flex;
  ${({ clickable }) => (clickable ? 'cursor: pointer;' : '')};
  width: ${({ items, short }) => (short ? 100 / (items * 2) : 100 / items)}%;
`

const stickHeight = `
    height: .16vw;

    ${iPadDown} {
        height: 1px;
    }
`

export const StickContainer = styled.div`
  align-items: center;
  display: flex;
  flex-grow: 1;
`

interface StickBackgroundProps {
  dolaTheme: DolaThemes
}

export const StickBackground = styled.div<StickBackgroundProps>`
  background: ${({ dolaTheme }) => theme[dolaTheme].default.stick};
  width: 100%;
  ${stickHeight}
`

export const StickContent = styled.div<NumberIconProps>`
  background: ${({ mode, dolaTheme }) => theme[dolaTheme][mode].stick};
  transition: width 0.4s ease;
  width: ${({ mode }) => (mode === 'active' ? '100%' : 0)};
  ${stickHeight}
`
